import {
  Button,
  ButtonColor,
  ButtonWidth,
  IconLightning,
  IconPhone,
} from '@leland-dev/leland-ui-library';
import { useRouter } from 'next/router';
import React, { type FC } from 'react';

import { useAuth } from '../../context/AuthContext';
import mxpnl from '../../utils/analytics/mixpanel';
import phog from '../../utils/analytics/posthog/posthog';
import { STRATEGY_CALL_CAL_URL, TYPEFORM_URLS } from '../../utils/constants';
import { getUrlString } from '../../utils/url';

interface GetRecommendationsBannerProps {
  trackingVars?: Record<string, Optional<string>>;
}

const MXPNL_TRACKING_EVENT = 'SRP - click - Get Recommendations';

const GetRecommendationsBanner: FC<GetRecommendationsBannerProps> = ({
  trackingVars,
}) => {
  const { currentUser } = useAuth();
  const router = useRouter();

  const href = getUrlString(
    TYPEFORM_URLS.GET_RECOMMENDATIONS,
    {
      first_name: currentUser?.firstName,
      last_name: currentUser?.lastName,
      email: currentUser?.email,
      id: currentUser?.applicant?.id,
      referrer: router.asPath,
    },
    { useHash: true },
  );

  return (
    <div className="flex flex-col items-center justify-between gap-4 rounded border border-leland-gray-stroke p-6 shadow-sm sm:flex-row">
      <div className="flex items-center gap-4">
        <IconLightning className="size-6 shrink-0" />

        <header>
          <h3 className="text-lg font-medium">
            Not sure? Get personalized coach recommendations.
          </h3>
          <h4 className="mt-1 text-lg text-leland-gray-light">
            Finding the perfect coach can be overwhelming. Let us help match you
            with your coach.
          </h4>
        </header>
      </div>
      <div className="flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
        <a
          className="w-full"
          href={STRATEGY_CALL_CAL_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            label="Schedule a call"
            LeftIcon={IconPhone}
            width={ButtonWidth.FULL_MOBILE}
            onClick={() => {
              mxpnl.track(MXPNL_TRACKING_EVENT, {
                ...trackingVars,
                cta: 'call',
              });
              phog.capture('srp--get_recommendations_banner_click', {
                ...trackingVars,
                cta: 'call',
              });
            }}
            id="get_recommendations_banner--schedule_call"
          />
        </a>
        <a
          className="w-full"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            label="Get recommendations"
            buttonColor={ButtonColor.BLACK}
            width={ButtonWidth.FULL_MOBILE}
            onClick={() => {
              mxpnl.track(MXPNL_TRACKING_EVENT, {
                ...trackingVars,
                cta: 'recommendations',
              });
              phog.capture('srp--get_recommendations_banner_click', {
                ...trackingVars,
                cta: 'recommendations',
              });
            }}
            id="get_recommendations_banner--get_recommendations"
          />
        </a>
      </div>
    </div>
  );
};

export default GetRecommendationsBanner;
